module.exports = __webpack_public_path__ + "img/pile-position.0966e282.png";